import { SearchDistrict } from '../../apis/district/SearchDistrict';

export const DistrictService = {
  search: async (regionId?: number, cityId?: number) => {
    return await SearchDistrict(regionId, cityId);
  },
};
